import React, { useMemo, useRef, useState } from "react";
import styled, { css } from "styled-components";
import iconWinner from "../../../../assets/images/Event-2025/icon-winner.png";
import FooterDetail from "./FooterDetail";
import { dataDetail, ID_PRIZE } from "./DefineData";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import bgImg from "../../../../assets/images/Event-2025/Frame-56-tiny.png";
import WinnerComponent from "./Winner";
import PopupCongrats from "./Popup/PopupCongrats";
import { POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT } from "../../../../helper/const";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  postApiTakePrize,
  setDataPopupError,
} from "../../../../Redux/futures/thingyan-2025/action";
import HeaderAction from "./HeaderAction";

export default function DetailProduct({
  itemProductActive,
  dataAwardActive,
  setDataAwardActive,
  handleShowDetailItem,
  isRunout
}) {
  const [isOpenPopupSurface, setIsOpenPopupSurface] = useState(false);
  const loading = useRef(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filterData = useMemo(() => {
    const newData = dataDetail.filter((item) => item.id === itemProductActive);

    let isCompletePiece = true;
    const dataConvert = newData.map((item = {}) => {
      const itemFormat = item.srcImg.map((detail) => {
        let newItem = {};
        dataAwardActive?.forEach((award = {}) => {
          if (!award.num) {
            isCompletePiece = false;
          }

          if (award.name == detail.name) {
            newItem = {
              ...award,
              ...detail,
            };
          }
        });
        return {
          ...detail,
          ...newItem,
        };
      });

      return {
        ...item,
        srcImg: itemFormat,
      };
    });

    return { data: dataConvert, isCompletePiece };
  }, [itemProductActive, dataAwardActive]);

  const afterTakePrize = (data, isLoading, dataError) => {
    if (!isLoading) {
      loading.current = false;
      if (!data || !dataError?.success) {
        dispatch(
          setDataPopupError({
            isOpen: true,
            message: dataError?.errorMessage,
          })
        );
      }
    }
    if (data) {
      if (data?.success) {
        setIsOpenPopupSurface(true);
        setDataAwardActive(data.data);
      }
    }
  };

  const handleTakePrize = async () => {
    if (!loading.current) {
      loading.current = true;
      const dataApi = {
        callback: afterTakePrize,
        award_id: itemProductActive,
      };
      await dispatch(postApiTakePrize(dataApi));
    }
  };

  const isMobileXxl = useMediaQuery(`(max-width: ${mediaQueryPoint.xxl}px)`);

  return (
    <>
      {isOpenPopupSurface ? (
        <PopupCongrats
          variant={VARIANT.surfaceComplete}
          surfaceData={filterData.data ? filterData.data[0] : {}}
          open={isOpenPopupSurface}
          onCancel={() => setIsOpenPopupSurface(false)}
          getContainer={true}
        />
      ) : null}

      <ContainerDetail>
        <img src={bgImg} className="img-bg" />
        <div className="content-product">
          {/* <WinnerComponent /> */}
          <div className="main-content">
            <div className="container-main__content">
              {filterData.data.map((item) => {
                if (item.id === ID_PRIZE.prize_1) {
                  return (
                    <ContainerPiece
                      quantityItem={item?.quantityColumns || 3}
                      key={item.id}
                      className="main-content__container"
                    >
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${item.id}_${index}`}
                            className="item-img__piece"
                          >
                            <div
                              className={`img-child__${
                                index + 1
                              } position-relative`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${
                                    !itemImg.num ? "img-brightness" : ""
                                  }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </ContainerPiece>
                  );
                }

                if (
                  item.id === ID_PRIZE.prize_6 ||
                  item.id === ID_PRIZE.prize_7
                ) {
                  return (
                    <ContainerPiece1 className="main-content__container">
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${index}`}
                            className="item-img__piece h-178"
                          >
                            <div
                              className={`position-relative img-child2__${
                                index + 1
                              }`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${
                                    !itemImg.num ? "img-brightness" : ""
                                  }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </ContainerPiece1>
                  );
                }

                if (item.id === ID_PRIZE.prize_8) {
                  return (
                    <ContainerPiece3
                      quantityItem={item?.quantityColumns || 3}
                      key={item.id}
                      className="main-content__container special-product"
                    >
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${index}`}
                            className="item-img__piece h-178"
                          >
                            <div
                              className={`position-relative img-child2__${
                                index + 1
                              }`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${
                                    !itemImg.num ? "img-brightness" : ""
                                  }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </ContainerPiece3>
                  );
                }

                return (
                  <ContainerPiece2
                    className="main-content__container"
                    quantityItem={item?.quantityColumns || 3}
                    key={item.id}
                  >
                    {item.srcImg.map((itemImg, index) => {
                      return (
                        <div
                          key={`src_${index}`}
                          className={`item-img__piece h-178 ${
                            item.id === 5 ? "item-img__piece_5" : ""
                          }`}
                        >
                          <div
                            className={`position-relative img-child2__${
                              index + 1
                            }`}
                          >
                            <div className="position-relative w-max">
                              <div
                                className="deleted"
                                onClick={() => handleShowDetailItem(itemImg)}
                              />
                              <img
                                src={itemImg.src}
                                alt="img-piece"
                                className={`${
                                  !itemImg.num ? "img-brightness" : ""
                                }`}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </ContainerPiece2>
                );
              })}
            </div>
            <div className="content-active">
              <div
                className={` ${
                  filterData.data[0]?.id === ID_PRIZE.prize_1 ||
                  filterData.data[0]?.id === ID_PRIZE.prize_7 ||
                  filterData.data[0]?.id === ID_PRIZE.prize_6
                    ? "content-container-prize1"
                    : "content-container-prize"
                } ${
                  filterData.data[0]?.id === ID_PRIZE.prize_6 ||
                  filterData.data[0]?.id === ID_PRIZE.prize_7
                    ? "content-container-prize-5"
                    : filterData.data[0]?.id === ID_PRIZE.prize_8
                    ? "content-container-prize-8"
                    : ""
                }`}
              >
                <div className="content-detail shrikhand-regular m-0 p-0">
                  {filterData.data[0]?.title}
                </div>

                
              </div>
            </div>
          </div>
        </div>
      </ContainerDetail>
      <FooterDetail
        contentBtn={t("event_thingyan.home_page.take_prize")}
        action={handleTakePrize}
        isActiveButton={filterData.isCompletePiece}
      />
      <div className="text-run-out">
                  {isRunout
                    ? t(
                        "event_thingyan.pop_up.All of this prize have been claimed. Collect puzzles and take other available prizes soon"
                      )
                    : t("event_thingyan.pop_up.Prize quantities are limited. Collect Puzzles and Take Prize now to be the lucky winner")}
                </div>
    </>
  );
}

const cssBefore = css`
  content: "";
  position: absolute;
  width: calc(100% + 2px);
  height: 100%;
  z-index: 2;
  pointer-events: none;
`;

const ContainerPiece3 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 154px) 154px 154px calc(50% - 154px);

  .w-max {
    width: max-content;
  }

  .img-child2__12 {
    .w-max::before {
      ${cssBefore};
      border-bottom-right-radius: 5px;
      border-bottom: 4px solid white;
    }
  }

  .img-child2__11,
  .img-child2__10 {
    .w-max::before {
      ${cssBefore};
      border-bottom: 4px solid white;
    }
  }

  .img-child2__9 {
    .w-max::before {
      ${cssBefore};
      border-bottom-left-radius: 5px;
      border-left: 4px solid white;
      border-bottom: 4px solid white;
    }
  }

  .img-child2__1 {
    .w-max::before {
      ${cssBefore};
      border-top-left-radius: 5px;
      border-left: 4px solid white;
      border-top: 4px solid white;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__4 {
    .w-max::before {
      ${cssBefore};
      border-top: 4px solid white;
    }
  }

  .img-child2__4 .w-max::before {
    border-top-right-radius: 5px;
  }

  .img-child2__5 {
    .w-max::before {
      ${cssBefore};
      border-left: 4px solid white;
    }
  }

  .img-child2__4,
  .img-child2__8,
  .img-child2__12 {
    .w-max::before {
      ${cssBefore};
      border-right: 4px solid white;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__6,
  .img-child2__7,
  .img-child2__10,
  .img-child2__11 {
    display: flex;
    justify-content: center;
  }

  .img-child2__1,
  .img-child2__5,
  .img-child2__9 {
    display: flex;
    justify-content: end;
    position: relative;
  }

  .img-child2__9 {
    left: 57px;
  }

  .img-child2__9,
  .img-child2__11 {
    position: relative;
    top: -66px;
  }

  .img-child2__10,
  .img-child2__12 {
    top: -83px;
    position: relative;
  }

  .img-child2__12 {
    left: -40px;
  }

  .img-child2__4,
  .img-child2__8,
  .img-child2__12 {
    display: flex;
    justify-content: start;
  }

  .img-child2__2,
  .img-child2__6,
  .img-child2__10 {
    right: -20px;
  }

  .img-child2__3,
  .img-child2__7,
  .img-child2__11 {
    left: -19px;
  }

  .img-child2__1 {
    right: -58px;
  }

  .img-child2__4 {
    left: -40px;
  }

  .img-child2__5,
  .img-child2__7 {
    top: -41px;
  }

  .img-child2__6,
  .img-child2__8 {
    top: -25px;
  }

  .img-child2__5 {
    right: -41px;
  }
  .img-child2__8 {
    left: -56px;
  }
  @media (max-width: 576px) {
    scale: 0.65;
    padding-top: 0 !important;
    margin-top: -35px;
    margin-bottom: -20px;
  }
`;

const ContainerPiece1 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 100px) 200px calc(50% - 100px);

  .w-max {
    width: max-content;
  }

  .img-child2__2,
  .img-child2__5,
  .img-child2__8 {
    display: flex;
    justify-content: center;
  }

  .img-child2__1,
  .img-child2__4,
  .img-child2__7 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6,
  .img-child2__9 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -46px;
  }

  .img-child2__3 {
    left: -46px;
  }

  .img-child2__4 {
    right: -25px;
  }

  .img-child2__4,
  .img-child2__6 {
    top: -52.5px;
  }

  .img-child2__7,
  .img-child2__9 {
    top: -84px;
  }

  .img-child2__8 {
    top: -105px;
  }
  .img-child2__9 {
    left: -46px;
  }

  .img-child2__7 {
    right: -46px;
  }

  .img-child2__6 {
    left: -45px;
  }

  .img-child2__5 {
    top: -30.5px;
  }

  .img-child2__1 .w-max::before,
  .img-child2__2 .w-max::before,
  .img-child2__3 .w-max::before,
  .img-child2__4 .w-max::before,
  .img-child2__5 .w-max::before,
  .img-child2__6 .w-max::before,
  .img-child2__7 .w-max::before,
  .img-child2__8 .w-max::before,
  .img-child2__9 .w-max::before {
    ${cssBefore};
    border: 4px solid white;
    border-radius: 5px;
  }

  .img-child2__7 .w-max::before,
  .img-child2__8 .w-max::before,
  .img-child2__9 .w-max::before {
    bottom: 4px;
    pointer-events: none;
  }

  .img-child2__3 .w-max::before,
  .img-child2__6 .w-max::before,
  .img-child2__9 .w-max::before {
    right: 0;
    pointer-events: none;
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__4,
  .img-child2__5,
  .img-child2__7,
  .img-child2__8 {
    .w-max::before {
      border-right: 0px;
      pointer-events: none;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6,
  .img-child2__8,
  .img-child2__9 {
    .w-max::before {
      border-left: 0px;
      pointer-events: none;
    }
  }

  .img-child2__5 {
    left: 0px;
    img {
      max-width: max-content;
    }
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6,
  .img-child2__4 {
    .w-max::before {
      border-bottom: 0px;
      height: calc(100%);
      pointer-events: none;
    }
  }

  .img-child2__4,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-top: 0;
      bottom: 2px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__5 {
    .w-max::before {
      border-top: 0;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__6 {
    .w-max::before {
      border-top: 0;
      left: -2px;
      pointer-events: none;
    }
  }

  .img-child2__7,
  .img-child2__8,
  .img-child2__9 {
    .w-max::before {
      border-top: 0px;
      pointer-events: none;
    }
  }

  .img-child2__6 {
    left: -25px;
  }

  @media (max-width: 576px) {
    scale: 0.7;
    padding-top: 0 !important;
    margin-top: -40px;
    margin-bottom: 20px;
  }
`;

const ContainerPiece = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.quantityItem}, 1fr);

  .w-max {
    width: max-content;
  }

  .item-img__piece {
    position: relative;
    width: 100%;
    height: 300px;

    .img-child__1,
    .img-child__3 {
      display: flex;
      justify-content: right;
    }

    .img-child__3 {
      right: 32px;
      top: -99px;
      .position-relative {
        width: max-content;
      }
    }

    .img-child__1 {
      right: -38px;
    }

    .img-child__3 {
      right: -6px;
    }
    .img-child__4 {
      top: -67px;
      left: -32px;
    }

    .img-child__1 .w-max::before,
    .img-child__2 .w-max::before,
    .img-child__3 .w-max::before,
    .img-child__4 .w-max::before {
      ${cssBefore};
      width: 100%;
      border: 4px solid white;
      border-radius: 5px;
    }

    .img-child__1 .w-max::before {
      border-right: 0px;
      border-bottom: 0px;
      pointer-events: none;
    }

    .img-child__2 .w-max::before {
      border-left: 0px;
      border-bottom: 0px;
      pointer-events: none;
    }

    .img-child__3 .w-max::before {
      border-right: 0px;
      border-top: 0px;
      bottom: 3px;
      pointer-events: none;
    }

    .img-child__4 .w-max::before {
      border-left: 0px;
      border-top: 0px;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .h-178 {
    height: 178px;
  }
  .img-child2__1,
  .img-child2__4 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -39px;
  }
  .img-child2__3 {
    left: -39px;
  }

  @media (max-width: 768px) {
    scale: 0.8;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0 auto;
    padding-top: 0;
    margin-top: -40px;
  }

  @media (max-width: 576px) {
    scale: 0.5;
    margin-top: -110px;
    padding-top: 0 !important;
    margin-bottom: -25px;
  }
`;

const ContainerPiece2 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 100px) 200px calc(50% - 100px);
  margin: 0 auto;
  margin-top: 50px;
  max-width: 804px;
  justify-content: center;

  .w-max::after {
    bottom: 6px !important;
    border-radius: 5px;
    pointer-events: none;
  }

  .w-max {
    width: max-content;
  }

  .img-child2__2,
  .img-child2__5 {
    display: flex;
    justify-content: center;
  }

  .img-child2__1,
  .img-child2__4 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -25px;
  }

  .img-child2__3 {
    left: -24px;
  }

  .img-child2__4 {
    right: -46px;
  }

  .img-child2__4,
  .img-child2__6 {
    top: -27px;
  }

  .img-child2__6 {
    left: -45px;
  }

  .img-child2__5 {
    top: -49px;
  }

  .img-child2__1 .w-max::before,
  .img-child2__2 .w-max::before,
  .img-child2__3 .w-max::before,
  .img-child2__4 .w-max::before,
  .img-child2__5 .w-max::before,
  .img-child2__6 .w-max::before {
    ${cssBefore};
    border: 4px solid white;
    border-radius: 5px;
    left: -1px;
    right: -1px;
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__4,
  .img-child2__5 {
    .w-max::before {
      border-right: 0px;
      pointer-events: none;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-left: 0px;
      pointer-events: none;
    }
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__3 {
    .w-max::before {
      border-bottom: 0px;
      height: calc(100%);
      pointer-events: none;
    }
  }

  .img-child2__4,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-top: 0;
      bottom: 2px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__5 {
    .w-max::before {
      border-top: 0;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__3 {
    left: -24.5px;
  }

  .item-img__piece_5 .img-child2__6 {
    left: -46px;
  }

  .item-img__piece_5 .img-child2__6 {
    .w-max::before {
      border-top: 0;
      left: -2px;
      pointer-events: none;
    }
  }

  @media (max-width: 576px) {
    justify-content: center;
    margin: 0 auto;
    scale: 0.7;
    margin-bottom: -70px;
    padding-top: 0 !important;

    .img-child2__1 {
      right: -23px;
    }
    .img-child2__3 {
      left: -23px;
    }

    .img-child2__4 {
      right: -44px;
    }

    .img-child2__6 {
      left: -44px;
    }
  }

  @media (max-width: 440px) {
    scale: 0.65;
    padding-top: 0 !important;
    margin-top: -55px;
  }
`;

const ContainerDetail = styled.div`
  margin: 0 36px;
  position: relative;
  /* .content-detail.m-0,
  .content-detail.p-0 {
    margin: 0;
    padding-bottom: 0;
  } */



  .deleted {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    cursor: pointer;
    z-index: 4;
  }

  .img-brightness {
    filter: brightness(0.5);
  }

  .w-max::after {
    content: "";
    position: absolute;
    height: calc(100% - 4px);
    width: calc(100% - 4px);
    z-index: 2;
    width: 100%;
    background-color: white;
    left: 0;
    pointer-events: none;
  }

  .w-max::before {
    z-index: 4 !important;
    pointer-events: none;
  }

  .w-max img {
    position: relative;
    z-index: 3;
  }

  .background-gradient {
    width: 100%;
    height: 100%;
    position: relative;
    &::before {
      content: "";
      pointer-events: none;
      position: absolute;
      .background-gradient {
        width: 8px;
        height: 100%; // Hoặc một giá trị cụ thể nếu cần
        background: linear-gradient(to bottom, #ffffff 0%, #a1dbfd 100%);
        border-radius: 16px;
      }
    }
  }

  .content-detail {
    @import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Grechen+Fuemen&family=Karla:ital,wght@0,200..800;1,200..800&family=Lobster&family=Londrina+Solid:wght@100;300;400;900&family=Mulish:ital,wght@0,300;1,300&family=Noto+Sans+Myanmar:wght@100;200;300;400;500;600;700;800;900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Shrikhand&family=Vina+Sans&display=swap");
    margin-bottom: 40px;
    font-size: 40px;
    padding-bottom: 90px;
    background: linear-gradient(to bottom, #ffffff 25%, #a5deff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    filter: drop-shadow(2px 0 0 #176ee5) drop-shadow(-2px 0 0 #176ee5)
      drop-shadow(0 5px 0 #176ee5) drop-shadow(0 -2px 0 #176ee5) !important;
  }

  .img-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 31px;
    border: 8px solid transparent;
    background: linear-gradient(to top, #ffffff 0%, #a1dbfd 100%) border-box;
  }

  .main-content {
    /* background-image: url(${(props) => props.bgDetail});
    background-size: cover;
    background-repeat: no-repeat; */
    padding: 20px;
    position: relative;
    top: 0;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
  }

  .main-content__container {
    padding-top: 40px;
  }

  .bg-detail {
    width: 100%;
    height: 100%;
  }

  .content-product {
    position: relative;
  }

  .icon-winner__collect {
    width: 80px;
    z-index: 2;
    position: absolute;
    left: -20px;
    top: -3px;
  }

  .content-active {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

  .content-container-prize1 {
    margin-top: -85px;
    margin-bottom: 55px;
  }

  .content-container-prize {
    margin-top: -35px;
    margin-bottom: 65px;
  }

  /* .content-container-prize-8 {
    margin-top: -72px;
  } */

  @media (max-width: 768px) {
    .content-container-prize1 {
      margin-top: -155px;
      margin-bottom: 55px;
    }

    .main-content__container {
      width: 565px;
    }

    .special-product {
      width: 650px;
    }

    .container-main__content {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      scale: 0.9;
    }

    .content-container-prize-5 {
      margin-top: -125px;
    }

    .content-container-prize-8 {
      margin-top: -85px;
    }
  }

  @media (max-width: 576px) {
    .content-container-prize1 {
      margin-top: -195px;
      margin-bottom: 55px;
    }

    .icon-winner__collect {
      width: 60px;
    }

    .content-detail {
      font-size: 24px;
    }

    .icon-winner__collect {
      left: -5px;
      top: -8px;
    }

    .content-container-prize-8 {
      margin-top: -115px;
    }
  }

  @media (max-width: 440px) {
    margin: 0 8px;
    .content-container-prize {
      margin-bottom: 45px;
    }

    .content-container-prize {
      margin-top: -40px;
    }

    .content-container-prize-8 {
      margin-top: -115px;
    }
  }

  @media (min-width: 992px) {
    /* .main-content__container{
      height: 595px;
    } */
    .content-active {
      /* margin-top: -45px; */
    }

    .content-container-prize1 {
      margin-top: -108px;
      margin-bottom: 55px;
    }
  }

  @media (min-width: 1400px) {
    /* padding-left: 40px; */
    margin: 0 85px;
  }
`;
